import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { IncidentHyperlinkTypeModel } from "../models/incident-hyperlinktype.model";

@Injectable({
    providedIn: "root",
})
export class IncidentHyperlinkTypeService {
    private httpClient: HttpClient = inject(HttpClient);
    private baseUrl = `${localStorage.getItem("incidentUrl")}/api/hyperlink-types`;

    public getHyperlinkTypes(): Observable<IncidentHyperlinkTypeModel[]> {
        return this.httpClient.get<IncidentHyperlinkTypeModel[]>(`${this.baseUrl}/getall`);
    }
}
